module.exports = __webpack_public_path__ + "static/img/ERITEMA.40442b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/ERITEMA.jpg
// module id = m9FZ
// module chunks = 2